import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { ERROR_404_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";

import DiscountListPage from "./DiscountListPage";
import ReportsListPage from "./ReportsListPage";
import ShopThemeProvider from "./ShopThemeProvider";
import SupplementListPage from "./SupplementListPage";
import TestProductListPage from "./TestProductListPage";

export default function OrganisationShop() {
  const match = useRouteMatch();
  useDocTitle("Shop", false, "Regenerus");

  return (
    <ShopThemeProvider>
      <Switch>
        <Redirect from={match.path} to={`${match.url}/tests`} exact />
        <Route path={`${match.path}/supplements`} exact>
          <SupplementListPage />
        </Route>
        <Route path={`${match.path}/tests`} exact>
          <TestProductListPage />
        </Route>
        <Route path={`${match.path}/reports`} exact>
          <ReportsListPage />
        </Route>
        <Route path={`${match.path}/discounts`} exact>
          <DiscountListPage />
        </Route>
        <Redirect to={ERROR_404_URL} />
      </Switch>
    </ShopThemeProvider>
  );
}
